/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
import { useDispatch } from 'react-redux';
import { postMessageToClient } from '../chatservice/communicationService';
import { addAnalyticsEvent, updateAnalyticsStatus } from '../chatservice/dialogflowQuery';
import { MessageTypes } from '../models/enum';
import './message.scss';
import { getIntentGroupTypeId, getUniqueId } from '../../widget/util/commonUtil';
import { v4 } from 'uuid';
import { config } from '../../config/config.env';
import { hasUserInteractedWithBot } from '../../actions/index';

type messageLinkProps = {
    text: string,
    link: string,
    toggleWidget?: any,
    target?: string,
    sessionId?: any,
    userId?: any,
    intentGroupId?: any,
    intentGroupName?: any,
    type?: any
}

const MessageLink = ({text, link, toggleWidget, target, sessionId, userId, intentGroupId, intentGroupName, type }: messageLinkProps) => {
    const dispatch = useDispatch();
    const onClickHandler = (link:string, event: any) => {
        event.preventDefault();
        event.stopPropagation();
        dispatch(hasUserInteractedWithBot(true));

        postMessageToClient({name: "chatbotQRClicked", text: text});
        // if message type is DQR post a success to analytics when clicked.
        if (type === MessageTypes.DynamicQr || type === MessageTypes.Url) {
            let isSuccessful;

            try {
                let url = new URL(link);
                var path = url.pathname;
                isSuccessful = (path !== '/contact') ? true : null;
            } catch (_) {
                isSuccessful = null;
            }

            const analyticsData = {
                queryId : v4(),
                isSuccessful : isSuccessful,
                eventName: `URL_CLICK (${link})`,
                intentGroupId : intentGroupId,
                intentGroupName : intentGroupName,
                intentGroupTypeId : getIntentGroupTypeId(intentGroupName),
                source : config.SOURCE
            };
    
            addAnalyticsEvent(sessionId, userId, analyticsData);

        } else if (link.indexOf('1300138297') >= 0) {
            const analyticsData = {
                queryId : v4(),
                isSuccessful : false,
                eventName: 'CALL_CHUB',
                intentGroupId : intentGroupId,
                intentGroupName : intentGroupName,
                intentGroupTypeId : getIntentGroupTypeId(intentGroupName),
                source : config.SOURCE
            };
    
            addAnalyticsEvent(sessionId, userId, analyticsData);
        }

        

        if (target === 'route') {
            // init change url
            const objCall = {
                data: {
                    prodDetailsUrl: new URL(link).pathname,
                    storeId: '',
                    storeName: '',
                    queryString: { i_cid: 'cbprodtracking-loaddashboard' }
                },
                methodHandler: "chatbotInitChangeUrl"
            };

            //minimize widget
            if (toggleWidget)
                toggleWidget(false);
            postMessageToClient(objCall);
        } else if (target === 'self') {
            window.parent.location.href = link;
        } else {
            window.open(link, "_blank");
        }
    }
    
    const externalLink = (type && (type === MessageTypes.Form || type === MessageTypes.DynamicQr || type === MessageTypes.Url) && (link.indexOf('tel:') === -1) && sessionId && userId && intentGroupId) ? `${link}&msid=${sessionId}&muid=${userId}&migid=${intentGroupId}` : link;
    
    return (
        <div className='message__text--quick-reply'>  
                <a href={ externalLink } onClick={(event) => onClickHandler(externalLink, event)} className="message__link" id={getUniqueId('message-link', text)} target="_blank" rel="noreferrer">
                    <span>{text}</span>
                    <img src="/images/external-link-chip.svg" alt="" /> 
                </a>
                          
        </div>
    )
}

export default MessageLink
 